import React from 'react'
import { CSSTransition } from 'react-transition-group'

import { PrecinctListItemInterface } from '@api/houseAndLand'

import AreaList, { Area } from './area-list'

type PrecinctProps = {
  className?: string
  containerClassName?: string
  precincts: PrecinctListItemInterface[]
  selectedPrecinct: string | undefined
  onSelect: (id: string) => void
}

function Precinct({
  className = '',
  containerClassName = '',
  precincts,
  selectedPrecinct,
  onSelect,
}: PrecinctProps) {
  const areaListProp = React.useMemo<Area[]>(
    () =>
      precincts.map<Area>((item) => ({
        id: item.id,
        name: item.label,
        selected: selectedPrecinct === item.label,
      })),
    [precincts, selectedPrecinct]
  )

  const handleClick = React.useCallback(
    (item: Area) => {
      onSelect(item.name)
    },
    [onSelect]
  )

  return (
    <CSSTransition
      classNames="transition-property-compare-toggle"
      timeout={300}
      in
      appear
      mountOnEnter
      unmountOnExit
    >
      <div className={`h-full w-full ${className}`}>
        <div
          className={`custom-scrollbar h-full w-full overflow-y-auto ${containerClassName}`}
        >
          <AreaList data={areaListProp} onClick={handleClick} />
        </div>
      </div>
    </CSSTransition>
  )
}

export default Precinct
